import { InstanceScreen } from 'component/navigation/instance';

export default function ArticleDebugVideoVotingScreen() {
    return <InstanceScreen screenKey='debugVideoVoting' />;
}
